import tw from "tailwind-styled-components";

export const Title = tw.h2`text-lg font-bold`;
export const SubTitle = tw.h2`text-sm text-gray-600`;
export const Heading = tw.div`text-base font-semibold`;
export const PayOnline = tw.button`bg-black flex justify-center gap-2 px-4 text-white h-11 items-center rounded-lg text-sm font-semibold w-full`;
export const InputLabel = tw.div`block text-sm font-medium mb-2`;
export const SubHeading = tw.p`text-sm md:text-[15px] font-normal`;
export const Image = tw.img`w-24 h-24 md:w-44 md:h-44 mx-auto`;
export const Box = tw.div`text-green-700 text-center p-4`;
export const DuesAmount = tw.p`text-xs text-gray-600`;
export const Amount = tw.p`text-base font-bold mb-2`;
export const PaymentOption = tw.div`flex items-center border border-gray-300 p-4 rounded-lg space-x-6`;
export const OptionLabel = tw.h4`text-base font-semibold`;
export const OptionSubLabel = tw.p`text-sm`;
export const SheetHeader = tw.div`border-b border-gray-200 p-4`;
export const SheetTitle = tw.h3`text-lg font-semibold text-center`;
export const CheckboxInput = tw.input`w-4 h-4 accent-[#07A5E2] bg-gray-100 border-gray-300 rounded focus:ring-blue-500`;
export const DueItem = tw.div`bg-white rounded-xl p-3 mb-3 border border-gray-200 shadow-sm`;
export const DueItemHeader = tw.div`flex justify-between items-start mb-2`;
export const DueItemTitle = tw.h4`text-base font-semibold text-gray-900`;
export const DueItemSubtitle = tw.p`text-xs text-gray-500`;
export const DueItemAmount = tw.p`text-base font-semibold text-gray-900`;
export const PayButton = tw.button`w-full bg-black text-white rounded-md h-11 flex items-center justify-center font-semibold text-sm`;
export const PayOfflineButton = tw.button`w-full bg-transparent text-black rounded-md h-11 flex items-center justify-center font-semibold text-sm border border-black`;